<!-- Regel und Datei je in eigener Zeile (lange Namen werden einzeln gekürzt, mit Tooltip),
     darunter linksbündig der Link zum Ergebnis. -->
<div [class]="(failed ? 'bg-red-50' : 'bg-green-50') + ' flex w-full flex-row items-start gap-3 rounded-md p-4 shadow-full'">
  <fa-icon [class]="(failed ? 'text-red' : 'text-green') + ' mt-0.5 text-svg-18'"
           [icon]="failed ? faCircleXmark : faCircleCheck"></fa-icon>

  <div class="flex min-w-0 flex-1 flex-col gap-0.5">
    <div class="text-sm font-medium text-gray">
      {{ failed ? 'Testlauf fehlgeschlagen' : 'Testlauf abgeschlossen' }}
    </div>
    @if (data?.ruleLabel) {
      <div [title]="data?.ruleLabel ?? ''" class="truncate text-xs text-gray-700">{{ data?.ruleLabel }}</div>
    }
    @if (data?.fileNames) {
      <div [title]="data?.fileNames ?? ''" class="flex min-w-0 items-center gap-1.5 text-xs text-gray-500">
        <fa-icon [icon]="faFile" class="shrink-0"></fa-icon>
        <span class="truncate">{{ data?.fileNames }}</span>
      </div>
    }
    <button (click)="openResult()"
            class="mt-1 self-start text-sm font-medium text-green-700 hover:underline"
            type="button">
      Ergebnis ansehen →
    </button>
  </div>

  <fa-icon [icon]="faXmark" class="text-gray-400"></fa-icon>
</div>
